import React from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import { useNotify, useRecordContext } from 'react-admin';
import axios from 'axios';

const ResendSignupButton = () => {
    const notify = useNotify();
    const record = useRecordContext();
    const handleClick = () => {
        axios({method: "POST", url: `/api/v1/users/${record.id}/resend`, data: {'token_type': 'signup'}})
        .then(resp=>{
            notify(`Resent Verification Email to ${record.contactName}`);
        })
        .catch(err => {
            if (err.response == 400) {
                //TODO: bad request
            }
            else if (err.response.status == 422) {
                notify(err.response.data.error.toString());
            }
        });
    };

    return (
        <Button color="primary" disabled={record === undefined || record.verified} onClick={handleClick}>Resend Signup</Button>
    );
};

ResendSignupButton.propTypes = {
    record: PropTypes.object,
};

export default ResendSignupButton;